import { cva, type VariantProps } from 'class-variance-authority';

export type TooltipButtonVariants = VariantProps<typeof tooltipButtonVariants>;
export const tooltipButtonVariants = cva(
  'underline decoration-dashed underline-offset-4 leading-5 cursor-pointer',
  {
    variants: {
      intent: {
        tooltip: 'decoration-slate-lighter-40',
        popover: 'decoration-viridian-base'
      }
    }
  }
);

export const popoverTooltipContentVariants = cva(
  'font-b-s absolute z-[10000] min-h-max min-w-[250px] max-w-[20rem] transform animate-fadeIn rounded-lg bg-slate-base p-4 text-white shadow md:w-max [&_a]:text-white'
);
